<!-- skiiippv -->
<!-- skiiippvvds -->
<div class="container-fluid InfoForm thin-scroll">
    <div class="header my-2 d-flex align-items-center justify-content-between p-1">
        <h6 class="m-0"><span class="headertxt"> {{extraAttributeObject.value.header}} Information : </span></h6>
        <button (click)="showEditMode()" class="previewbtn text-center btn float-right" *ngIf="canChange">
            <img src="../../../../../assets/shoppingCart/edit.png" class="imgIcon" />
            <span class="mx-1 text-white"> Edit</span>
        </button>
    </div>
    <hr class="" />
    <div class="pr-3">
        <div class="row p-3">
            <!-- Boolean View (not editable) -->

  
            <ng-container *ngFor="let attrMeta of appTransactionsForViewDto?.extraDataAttributes">
                
                <ng-container *ngIf="attrMeta.extraAttrDataType === 'boolean'; else normalView">
                    <div class="col-md-6 mb-3">
                      <div>
                        <label class="font-weight-bold">{{ attrMeta.extraAttrName | localize }}</label>
                      </div>
                      <div class="radio-inline mt-2">
                        <label class="radio radio-accent radio-primary mr-4" for="attrMeta{{attrMeta.name}}_1">
                          <input type="radio"
                                 name="attrMeta_{{attrMeta.name}}"
                                 id="attrMeta{{attrMeta.name}}_1"
                                 [value]="'true'"
                                 [checked]="attrMeta.selectedValues[attrMeta.selectedValues.length - 1]?.value === 'true'"
                                 style="pointer-events: none;"
                                 readonly
                                 class="custom-disabled-radio"
                  />
                          {{ "Yes" | localize }}
                        </label>
                        <label class="radio radio-accent radio-primary" for="attrMeta{{attrMeta.name}}_0">
                          <input type="radio"
                                 name="attrMeta_{{attrMeta.name}}"
                                 id="attrMeta{{attrMeta.name}}_0"
                                 [value]="'false'"
                                 [checked]="attrMeta.selectedValues[attrMeta.selectedValues.length - 1]?.value === 'false'"
                                 disabled
                                 class="custom-disabled-radio" />
                          {{ "No" | localize }}
                        </label>
                      </div>
                    </div>
                  </ng-container>
                  
                  <ng-template #normalView>
                    <div class="col-md-6 mb-3">
                      <div>
                        <label class="font-weight-bold">{{ attrMeta.extraAttrName | localize }}</label>
                      </div>
                      <div class="mt-1">
                        <ng-container *ngIf="attrMeta.selectedValues[attrMeta.selectedValues.length - 1]?.value">
                          <span *ngIf="attrMeta.extraAttrDataType === 'Datetime'">
                            {{ attrMeta.selectedValues[attrMeta.selectedValues.length - 1]?.value | date: 'dd MMMM yyyy' }}
                          </span>
                          <span *ngIf="attrMeta.extraAttrDataType !== 'Datetime'">
                            {{ attrMeta.selectedValues[attrMeta.selectedValues.length - 1]?.value }}
                          </span>
                        </ng-container>
                        <div *ngIf="!attrMeta.selectedValues[attrMeta.selectedValues.length - 1]?.value || attrMeta.selectedValues[attrMeta.selectedValues.length - 1]?.value === ''">
                          -
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  
            </ng-container>
        </div>
    </div>
    <hr class="my-2" />
</div>